import React from 'react'
import { ReactComponent as WarningIcon } from 'assets/icons/warning.svg'
import LoaderImg from 'shared/components/LoaderImg/LoaderImg'
import s from './styles/AiToolErrorBanner.module.scss'

export default function AiToolErrorBanner({
	message = "We couldn't load this list. Please try again later.",
	onRetry,
	retrying = false,
}) {
	return (
		<div className={s.banner} role="alert">
			<div className={s.copy}>
				<WarningIcon className={s.icon} aria-hidden />
				<span>{message}</span>
			</div>
			{typeof onRetry === 'function' ? (
				<button
					type="button"
					className={s.retry}
					onClick={onRetry}
					disabled={retrying}
				>
					{retrying ? <LoaderImg /> : null}
					Retry
				</button>
			) : null}
		</div>
	)
}
